// extracted by mini-css-extract-plugin
export default {"app-details-wrapper":"appDetails_app-details-wrapper__7AvnY"};